<template>
  <div class="listPanel" @click="goDetails(obj.id)">
    <el-card shadow="hover">
      <img :src="obj.imgUrl" alt="">
      <p class="p-name" v-html="obj.name"></p>
      <!-- <p class="p-oldMoney">
        {{obj.nowMoney}}
        <span>{{obj.oldMoney}}</span>
      </p> -->
      <p class="p-nowMoney">
        <strong>{{ obj.nowMoney ? obj.nowMoney : obj.oldMoney}}</strong>
        <span v-show="obj.nowMoney">定价:{{obj.oldMoney}}</span>
      </p>
      <p class="e-book">
        <span v-show="obj.bookPrice">
          电子书:<span>￥{{obj.paperPromotionPrice ? obj.paperPromotionPrice : obj.bookPrice}}</span>
          <span class="dzs" v-show="obj.paperPromotionPrice">{{obj.bookPrice}}</span>
        </span>
      </p>
      <p>{{obj.author}}</p>
      <div class="div-star" v-show="star">
        <el-rate
          v-model="obj.score"
          disabled
          show-score
          text-color="red"
          score-template="{value}颗星">
        </el-rate>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    obj: {
      type: Object,
      default: null
    },
    star: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  methods: {
    goDetails (id) {
      this.$router.push({
        name: 'GoodsDetails',
        query: {
          id: id
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .listPanel{
    text-align: center;
    cursor: pointer;
      text-align: left;
    img{
      width: 100%;
      height: 210px;
      display: block;
    }
    p{
      text-align: left;
      padding: 0 0 5px 0;
      margin: 0;
      font-size: 14px;
    }
    .p-name{
      padding: 8px 0;
      font-size: 16px;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
    .p-oldMoney{
      text-decoration:line-through;
      color: #A2A2A2;
    }
    .p-oldMoney::before{
      content: '￥'
    }
    .p-nowMoney{
      color: red;
      font-size: 16px;
      font-weight: 600;
      span{
        text-decoration:line-through;
        color: #A2A2A2;
        font-size: 14px;
        font-weight: 100;
      }
    }
    .p-nowMoney::before{
      content: '￥'
    }
    .e-book{
      color: #A2A2A2;
      font-size: 14px;
      height: 19px;
      .dzs{
        text-decoration: line-through;
      }
    }
    .div-star{
      text-align: left;
      .star-panel{
        height: 30px;
        width: 100px;
        background: red;
        display: inline-block;
      }
    }
  }
</style>
<style lang="less">
  .listPanel{
    height: 100%;
    .el-card{
      border: 0;
      height: 100%;
      .el-card__body{
        padding: 0 10px !important;
        height: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/listPanel.vue


// WEBPACK FOOTER //
// src/components/Home/listPanel.vue